import { getCookieValue } from './utilities';
import logForGoogleAnalytics from './logForGoogleAnalytics';

const SMARTDOLLAR_PARDOT_ACCOUNT_ID = '699043';
const PARDOT_VISITOR_ID = `visitor_id${SMARTDOLLAR_PARDOT_ACCOUNT_ID}`;
const PARDOT_COOKIE_NOT_FOUND = 'fw_pardot_cookie_missing';

/**
 * Sends the PardotId to Google Tag Manager (gtm)
 * @returns {void}
 */
const logPardotVisitor = () => {
  const referenceId = getCookieValue(PARDOT_VISITOR_ID);

  if (!referenceId) {
    logForGoogleAnalytics({ referenceId: PARDOT_COOKIE_NOT_FOUND });
    return;
  }

  logForGoogleAnalytics({ referenceId: referenceId });
};

export default logPardotVisitor;
